import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ChipInput, Text } from '@reveni-io/reveni-ui'

import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import * as Styles from './styles'

const TagsConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasError = errors.some(e => e.type === errorTypes.actionTagsEmpty)

  const handleChange = tags => onChangeConfig({ tags })

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Etiquetas de transacción')}</Text>
      <ChipInput
        label={t('Etiquetas de transacción')}
        value={config.tags || []}
        onChange={handleChange}
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={hasError}
        helperText={
          hasError
            ? t('Este campo es obligatorio')
            : t('Pulsa Enter o coma para añadir. Pega una lista separada por comas para añadir varios a la vez')
        }
      />
    </Styles.Container>
  )
}

export default TagsConfig
